const theme = {
  defaultTheme: "light",
  themes: {
    light: {
      dark: false,
      colors: {
        primary: "#3D5789", // general primary
        primaryText: "#0F162A", // text color
        primaryButton: "#007A55",
        secondryButton: "#21344E",
      },
    },
  },
};
export default theme;
